import { a } from '../global-constants';

export const setHasData = (payload) => {
	return {
		type: a.SET_HAS_DATA,
		payload
	};
};
